<script lang="ts">
	import { page } from '$app/state';
</script>

<svelte:head>
	<title>{page.data.title} - {page.data.publisher}</title>
	<meta name="description" content={page.data.description} />

	<!-- Favicon -->
	<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
	<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
	<link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
	<link rel="icon" type="image/png" sizes="192x192" href="/favicon-192x192.png" />

	<!-- Preconnect Iconify -->
	<link rel="preconnect" href="https://api.iconify.design" />
	<link rel="preconnect" href="https://api.mapbox.com" />

	<!-- Open Graph -->
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content={page.data.title} />
	<meta property="og:description" content={page.data.description} />
	<meta property="og:url" content={page.data.site_url} />
	<meta property="og:site_name" content={page.data.publisher} />
	<meta property="og:image" content={page.data.image.src} />
	<meta property="og:image:alt" content={page.data.image.alt} />

	<!-- Twitter -->
	<meta property="twitter:card" content="summary_large_image" />
	<meta property="twitter:url" content={page.data.site_url} />
	<meta property="twitter:image" content={page.data.image.src} />
	<meta property="twitter:title" content={page.data.title} />
	<meta property="twitter:description" content={page.data.description} />

	<!-- Google tag (gtag.js) -->
	<script async src="https://www.googletagmanager.com/gtag/js?id=G-PPD7NB7TR7"></script>
	<script>
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag('js', new Date());
		gtag('config', 'G-PPD7NB7TR7');
	</script>
	<!-- End Google Tag Manager -->
</svelte:head>
